<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex justify-center flex-column ga-4">
        <div class="justify-center flex-grow-0">
          <!-- <div class="mb-6" style="text-align: center">
            <img src="@/assets/logo.svg" width="200" />
          </div> -->
        </div>
        <v-card>
          <v-alert
            v-if="isNonProd"
            prominent
            elevation="2"
            color="warning"
            :closable="false"
            icon="mdi-alert-circle"
            class="pa-1 ma-2"
          >
            <v-alert-title>NONPROD ENVIRONMENT</v-alert-title>
            <v-alert-text
              >Testing environment only, changes made here will not affect prod
              data</v-alert-text
            >
          </v-alert>
          <v-card-text class="" v-if="isStaff">
            <div style="text-align: center">
              <img src="@/assets/COMPASS-NAVIGATOR.svg" height="75" />
            </div>
          </v-card-text>
          <v-card-text class="" v-else>
            <div style="text-align: center">
              <img src="@/assets/logo.svg" height="75" />
            </div>
          </v-card-text>
          <v-card-title v-if="isStaff" class="text-center mb-4"
            >COMPASS Staff Login</v-card-title
          >
          <v-card-title v-else class="text-center mb-4"
            >Navigator Portal Login</v-card-title
          >
          <LoginForm @submit="handleSubmit" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { useEnv } from "@/composables/useEnv";
const links = ["Front Office", "Dockhouse", "Admin"];
import { useRoute, useRouter } from "vue-router";
const router = useRouter();
const route = useRoute();
const redirect = computed(() => route.query.redirect);
function handleSubmit(type: string) {
  if (typeof redirect.value == "string") router.push(redirect.value);
  else router.push("/");
}
const env = useEnv();
const isStaff = computed(() => env.mode == "STAFF");
const isNonProd = computed(
  () =>
    window.location.hostname != "portal.community-boating.org" &&
    window.location.hostname != "compass.community-boating.org",
);
</script>

<style lang="scss" scoped>
.v-container {
  height: 100%;
  max-width: 30rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
